import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { NgIf } from '@angular/common'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { FormsModule } from '@angular/forms'

@Component({
    templateUrl: './multiline.component.html',
    styleUrls: ['./modal.css'],
    standalone: true,
    imports: [NgIf, FaIconComponent, FormsModule],
})
export class MultilineComponent {
    faInfoCircle = faInfoCircle
    constructor(private _activeModal: NgbActiveModal) {}

    public rows!: number
    public title!: string
    public showIcon!: boolean

    public setMessages(messages: string[]) {
        this.messages = messages.join('\r\n')
    }
    public messages!: string

    public ok(): void {
        this._activeModal.close()
    }
}
